// ------------------------------------
// Constants
// ------------------------------------
export const SERVICES_PUT_REQUEST = "SERVICES_PUT_REQUEST";
export const SERVICES_PUT_REQUEST_SUCCESS = "SERVICES_PUT_REQUEST_SUCCESS";
export const SERVICES_PUT_REQUEST_FAILURE = "SERVICES_PUT_REQUEST_FAILURE";
export const SERVICES_PUT_RESET = "SERVICES_PUT_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(serviceId, payload, resolve, reject, emulateFailure) {
  return {
    type: SERVICES_PUT_REQUEST,
    serviceId,
    payload,
    emulateFailure,
    resolve,
    reject,
  };
}

export function requestSuccess(data, payload) {
  return {
    type: SERVICES_PUT_REQUEST_SUCCESS,
    data,
    payload,
  };
}

export function requestFailure(error, payload) {
  return {
    type: SERVICES_PUT_REQUEST_FAILURE,
    error,
    payload,
  };
}

export function reset() {
  return {
    type: SERVICES_PUT_RESET,
  };
}
